import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";
import { FaHome, FaClipboardList, FaEnvelope, FaRobot, FaUsers, FaHandshake, FaToolbox, FaStar } from "react-icons/fa";
import { AiOutlineClose, AiOutlineMenu } from "react-icons/ai";

import useStore from "@/services/store";
import AppSelector from "@/components/SelectApp";

export default function Sidebar() {
  const { sideBarOpen, setSideBarOpen } = useStore();
  const { user } = useSelector((state) => state.Auth);

  useEffect(() => {
    if (window.innerWidth < 768) setSideBarOpen(false);
  }, []);

  if (!sideBarOpen) {
    return (
      <nav className="w-12 h-screen flex flex-col border-r border-gray-200 items-center justify-start fixed top-0 left-0 z-30">
        <div id="menu-icon" onClick={() => setSideBarOpen(true)} className="cursor-pointer mt-4">
          <AiOutlineMenu className="text-black text-2xl" />
        </div>
      </nav>
    );
  }

  return (
    <nav className="z-30 md:w-64 absolute top-0 left-0 ease-in-out duration-300">
      <div className="bg-white flex flex-col w-full h-screen overflow-y-scroll overflow-x-hidden border-r border-gray-200">
        <div className="flex justify-between items-center">
          <AppSelector userId={user._id} sideBarOpen={sideBarOpen} setSideBarOpen={setSideBarOpen} />
        </div>
        <div id="menu-icon" onClick={() => setSideBarOpen(false)} className="cursor-pointer absolute top-2 right-2">
          <AiOutlineClose className="text-black text-lg transition-opacity duration-300 opacity-100" />
        </div>
        <div className="space-y-2 flex-1">
          <div className="flex flex-col justify-between h-full">
            <div className="px-4 pb-1">
              <ul className="space-y-1">
                <li>
                  <NavLink
                    to="/githeo/campaigns"
                    className={({ isActive }) =>
                      `flex items-center gap-3 px-3 py-2 rounded-lg transition-all duration-200 text-sm font-medium ${
                        isActive ? "bg-gray-100 text-black shadow-inner" : "text-gray-700 hover:bg-gray-100 hover:text-black"
                      }`
                    }>
                    <span>Campaigns</span>
                  </NavLink>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}
